import React from "react";

import { AvatarThreeRow } from "components/avatar";
import CardMenu from "components/card/card-menu";
import { PostCardMenu } from "components/posts";
import { Localize } from "components/service";


const CardHeroTypeUser = (props) => {

    const {
        post : {
            author : {
                avatar,
                initials,
                nickname,
                name,
                status,
                email,
                autohaus_url,
                diamond_status,
            }
        }
    } = props;

    return(
        <div className="card-hero">
            <AvatarThreeRow
                photoUrl={ avatar }
                initials={ initials }
                blocked={ status === "block" ? "normal" : "" }
                size={ 45 }
                link={`/${ nickname }`}
                nickname={ nickname }
                title={ status !== "block" ? name : "" }
                diamondStatus={ diamond_status }
                text={
                    <>
                        { !!email && status !== "block" &&
                            email
                        }
                        { status === "block"  ? <Localize>GLOBAL.Text_InactiveUser</Localize> : "" }
                        { !!autohaus_url &&
                            <p>
                                <a href={`${ autohaus_url }`}
                                   target="_blank"
                                   rel="noopener noreferrer"
                                   className="outer-link"
                                >
                                    { autohaus_url }
                                </a>
                            </p>
                        }
                    </>
                }
                type="two"
            />
            <CardMenu>
                <PostCardMenu { ...props } />
            </CardMenu>
        </div>
    )

};

export default CardHeroTypeUser